import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { ProductCardListingsSkeleton } from '@/productDiscovery/Listings/components/ProductCardListingsEnhancer/components/ProductCardListingsSkeleton/ProductCardListingsSkeleton';
import { useModelId } from '@/productDiscovery/Listings/hooks/useModelId';

import styles from './ProductsSkeleton.module.scss';

export interface ProductsSkeletonProps {
  count: number;
  presentation?: 'technical' | 'inspirational';
}

export const ProductsSkeleton: FunctionComponent<ProductsSkeletonProps> = ({
  count,
  presentation = 'technical',
}) => {
  const isGSLP = Boolean(useModelId());

  return (
    <>
      {[...Array(count)].map((item, index) => {
        const promoted = isGSLP && index === 0;

        return (
          <div
            className={classnames(styles.product, {
              [styles.promotedRevamp]: promoted,
            })}
            key={`product-${index}`}
          >
            <ProductCardListingsSkeleton
              presentation={presentation}
              promoted={promoted}
            />
          </div>
        );
      })}
    </>
  );
};
